export default function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_reduced.js
// module id = ../node_modules/ramda/es/internal/_reduced.js
// module chunks = 5